import React from 'react';
import ImageUploader from './ImageUploader';
import './style.css';

const ImageListUploader = ({ disabledAdd, maxImageSize, storageFolder, fileList, setFileList }) => {
  return (
    <div className="image-list">
      <ImageUploader
        disabledAdd={disabledAdd}
        maxImageSize={maxImageSize}
        storageFolder={storageFolder}
        fileList={fileList}
        setFileList={setFileList}
        multiple={true}
      />
    </div>
  );
};

export default ImageListUploader;
